document.addEventListener('DOMContentLoaded', function () {
  var widget = document.getElementById('panda-wa-widget');
  if (!widget) return;
  var threshold = parseInt(widget.dataset.scrollThreshold, 10) || 1500;

  window.addEventListener(
    'scroll',
    function () {
      widget.classList.toggle('panda-is-visible', window.scrollY > threshold);
    },
    { passive: true }
  );
});
